<template>
  <div class="big">
    <div class="page_title">医生端埋点统计</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <span>事件名称</span>
          <el-input
            v-model="key_name"
            style="width: 150px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <span>统计时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width: 250px; margin: 0 10px"
            @change="search"
          >
          </el-date-picker>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
          >查询</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="buried_point_name"
              label="页面名称"
            >
              <template slot-scope="scope">
                <div>
                  {{scope.row.buried_point_name?scope.row.buried_point_name:scope.row.buried_point_code}}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              prop="key_name"
              label="事件名称"
            >
            </el-table-column>
            <el-table-column
              prop="pv"
              label="PV"
            ></el-table-column>

            <el-table-column
              label="UV"
              prop="uv"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="toDetail(scope.row)"
                  type="text"
                  :disabled="
                  module_id_array[0] ? !module_id_array.includes('1028') : false
                "
                >查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      key_name: '',
      date: [],
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'ios',
          label: 'ios'
        },
        {
          value: 'android',
          label: '安卓'
        },
        {
          value: 'shopapplet',
          label: '商城小程序'
        },
        {
          value: 'applet',
          label: '诊疗小程序'
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        platform: this.platform,
        key_name: this.key_name
      };
      if (this.date && this.date.length) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Buried/doctorBuriedPointClickList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //详情
    toDetail(row) {
      this.$router.push({
        path: '/home/activity/pointdata',
        query: {
          click_id: row.click_id,
          key_name: row.key_name,
          buried_point_name: row.buried_point_name,
          platform: row.platform,
          date: JSON.stringify([
            dayjs(this.date[0]).format('YYYY-MM-DD'),
            dayjs(this.date[1]).format('YYYY-MM-DD')
          ])
        }
      });
    }
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.date = [start, end];
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
</style>